import { render, staticRenderFns } from "./EmployeeBeneficiaryModal.vue?vue&type=template&id=259f59f6&scoped=true"
import script from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./EmployeeBeneficiaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f59f6",
  null
  
)

export default component.exports